import { AxiosResponse } from "axios";
import { apisiseci } from "./api";


interface ParamsServices {
  page: number;
  ativo: boolean;
  publico_especifico: string;
  categoria_slug?: string;
  search?: string;
  agendavel: boolean;
}
interface ParamsPassword {
  agendamento_id: number
  tipo_agendamento: string
}

export const getInterService = (token: string, id: number): Promise<AxiosResponse> =>
  apisiseci.get(`/cms/serv_internos/?servico=${id}`, {
    headers: {
      Authorization: `${token}`,
    },
  });

export const getUnidadeServices = (
  slug_unidade: string,
  page?: number
): Promise<AxiosResponse> => {
  let url = '';
  if (page) {
    url = `/cms/servicos_unidades/?unidade_slug=${slug_unidade}&page=${page}`;
  } else {
    url = `/cms/servicos_unidades/?unidade_slug=${slug_unidade}`;
  }

  const token = localStorage.getItem("gov_access_token_sso");
  return apisiseci.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  })
}


export const getService = (slug: string): Promise<AxiosResponse> => apisiseci
  .get(`/cms/servicos/?slug=${slug}`);

export const getCheckPriority = (token: string): Promise<AxiosResponse> => apisiseci
  .get(`/cms/prioridades/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });


export const getCheckPassword = (params: ParamsPassword, token: string): Promise<AxiosResponse> => apisiseci
  .get(`/cms/atendimento/obter-senha/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params
  });

export const getServiceWithParams = (params: ParamsServices, token: string): Promise<AxiosResponse> => apisiseci
  .get('/cms/servicos_busca/', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params,
  });

